import { selectPlaygroundWarehouses/* , selectPlaygroundMode */ } from 'containers/Playground/playgroundSlice'
// import { selectCartSelectedObjects } from 'setup/cart/cartSlice'
import { useReduxSelector } from 'store'
import Warehouse from './Warehouse'
import React from 'react'

type CartId = string
type ObjectId = string
export type SelectedObjects = Record<ObjectId, CartId>

const WarehouseList: React.FC = () => {
  // const mode = useReduxSelector(selectPlaygroundMode)
  const warehouses = useReduxSelector(selectPlaygroundWarehouses)
  // const selectedObjectsForRent = useReduxSelector(selectCartSelectedObjects)
  const objectsRef = React.useRef<HTMLDivElement>(null)

  return (
    <div
      ref={objectsRef}
      className='playground__objects'>
      {warehouses.map((e, idx) => <Warehouse
        {...e}
        key={idx}
        selectedObjects={
          // mode === 'renting' && selectedObjectsForRent ? getSelectedObjects(selectedObjectsForRent)
              // : 
              {}
        } />)}
    </div>
  )
}

// const getSelectedObjects = (selectedObjects: cart.Object<cart.SelectedObject>) => {
//   const init: SelectedObjects = {}
//   return Object.entries(selectedObjects).reduce((r, [k, v]) => {
//     r[v.id] = k
//     return r
//   }, init)
// }

export default WarehouseList